import { Locale, Trans, TFunction } from '@tuic/i18n';
import { VideoProps } from '@tuic/web-compositions/shared/Video';
import { urls } from '../urls';
export const getI18nForVideo = (locale: Locale, t: TFunction): VideoProps['i18n'] => {
  return {
    consentMessage: <Trans>
        Beim Abspielen des Videos können persönliche Daten an YouTube
        übermittelt werden. Mehr dazu in unseren{' '}
        <a href={urls.privacyPolicy({
        locale
      })} target="_blank">
          Datenschutzbestimmungen
        </a>
        .
      </Trans>,
    consentButtonLabel: t('Video aktivieren')
  };
};